export class UserBO {
    id: string;
    emailId: string;
    fullName: string;
}
